const mapData = require('./sensitive_words.json');

var mapUtil = {};
mapUtil.init=function(){
    var mapList = [];
    for(var i=0;i<mapData.length;i++){
        if(mapData[i].id == 7048 || mapData[i].id == 5627){
        }else{
            mapList.push(mapData[i].word);
        }
    }
    return mapList
}
export default mapUtil